import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4f6356a0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f6356a0')) {
      api.createRecord('4f6356a0', component.options)
    } else {
      api.reload('4f6356a0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4f6356a0", function () {
      api.rerender('4f6356a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/filesManage/index.vue"
export default component.exports